import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-content-list",
  templateUrl: "./content-list.component.html",
  styleUrls: ["./content-list.component.scss"],
})
export class ContentListComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() titleTable: any;
  @Input() list: any;
  @Input() modulo: string;
  @Input() register = true;
  @Input() activeUser: any;

  @Output() clickCreate = new EventEmitter();
  @Output() clickDelete = new EventEmitter();
  @Output() clickUpdate = new EventEmitter();
  @Output() clickDetail = new EventEmitter();
  @Output() clickDeleteTrash = new EventEmitter();
  @Output() clickAnalysis = new EventEmitter();

  search = "";
  orderBy = "";
  reverse: boolean;
  check: any = [];
  numPage = 10;
  pages = 1;
  public lang: string;

  constructor(private translate: TranslateService) {
    this.lang = this.translate.getDefaultLang();
  }

  ngOnInit() {
    this.lang = this.translate.currentLang;
    this.reverse = false;

    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf("edge") > -1:
        console.log("edge");

        return "edge";
      case agent.indexOf("opr") > -1:
        console.log("opera");
        return "opera";
      case agent.indexOf("chrome") > -1:
        this.reverse = true;
        return "chrome";
      case agent.indexOf("trident") > -1:
        console.log("trident");
        return "ie";
      case agent.indexOf("firefox") > -1:
        console.log("firefox");
        this.reverse = false;
        return "firefox";
      case agent.indexOf("safari") > -1:
        console.log("safari");
        return "safari";
      default:
        return "other";
    }
  }

  ngOnChanges() {
    if (this.list)
      this.list = this.list.map((item) => {
        return {
          ...item,
          fechaIncidenciaDate: new Date(item.fecha_incidencia),
        };
      });
  }

  create() {
    this.clickCreate.emit("create");
  }

  delete(data) {
    this.clickDelete.emit(data);
  }

  order(data) {
    this.reverse = this.orderBy === data ? !this.reverse : false;
    this.orderBy = data;
  }

  update(data) {
    this.clickUpdate.emit(data);
  }

  detail(data) {
    this.clickDetail.emit(data);
  }

  checkAll(event) {
    this.check = [];
    this.list.map((element) => {
      if (event.target.checked) {
        this.check.push(element.id);
        element.check = true;
      } else {
        element.check = false;
      }
    });
  }

  checkAcept(event, id) {
    if (event.target.checked) {
      this.check.push(id);
    } else {
      const value = this.check
        .map((d) => {
          return d;
        })
        .indexOf(id);
      this.check.splice(value, 1);
    }
  }

  deleteTrash() {
    this.clickDeleteTrash.emit(this.check);
  }

  analysis(data) {
    this.clickAnalysis.emit(data);
  }
}
